// extracted by mini-css-extract-plugin
module.exports = {"root":"Credits_root__14bB4","account_title":"Credits_account_title__2lJNZ","business_icon":"Credits_business_icon__1eua1","arrow_icon":"Credits_arrow_icon__2Xx7k"};